import { useMutation } from 'react-query';
import { RemoteLogging } from './LoggingRepo';
import MatchingAchievementLogSaveRq from '@domain/rq/match/MatchingAchievementLogSaveRq';

const loggingRepo = new RemoteLogging();

const saveMatchingAchievementLog = (rq: MatchingAchievementLogSaveRq) => {
  return loggingRepo.saveMatchingAchievementLog(rq);
};

export const useAchievementLog = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation(['achievementLog'], saveMatchingAchievementLog, {
    onSuccess,
    onError,
  });
};
